<template>
  <a v-if="href" :target="target" class="cta" :class="[{ small }, color]" :href="href">{{
    label
  }}</a>
  <router-link v-else :to="to" class="cta" :class="[{ small }, color]" :disabled="disabled">{{
    label
  }}</router-link>
</template>

<script>
export default {
  props: {
    label: {
      default: "label",
      type: String,
    },

    to: {
      type: Object,
    },

    href: {
      type: String,
    },

    target: {
      default: "_self",
      type: String,
    },

    disabled: {
      default: false,
      type: Boolean,
    },

    small: {
      default: false,
      type: Boolean,
    },

    color: {
      default: "pink",
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.cta {
  color: white;
  padding: 15px;
  display: inline-block;
  border-radius: 50px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  @include type-strong;

  &.small {
    padding: 5px;
    font-size: 16px;
  }

  &.pink {
    background: $pink;

    &:hover {
      background: $darkpink;
    }
  }

  &.blue {
    background: $blue;

    &:hover {
      background: $darkblue;
    }
  }

  & + .cta {
    margin-top: 10px;
  }

  @include media("<=phone") {
    width: 100%;
  }

  &[disabled] {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
}
</style>
